import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { Meteor } from 'meteor/meteor';

import { Modal, Nav } from 'react-bootstrap';

import MapIframe from './MapIframe';
import GraphicIframe from './GraphicIframe';
import TableIframe from './TableIframe';
import Text from './Text';
import ExpandModalButton from './ExpandModalButton';
import OpenLinkInNewWindowButton from './OpenLinkInNewWindowButton';

import { Section, Nav as StyledNav } from './styles';

const MODALS = {
  ONE: 'one',
  TWO: 'two',
  THREE: 'three',
  FOUR: 'four',
  FIVE: 'five'
};

const { defaultMapSource, defaultGraphicSource, defaultTableSource } = Meteor.settings.public;

const SectionsFive = ({
  firstSectionChild,
  secondSectionChild,
  thirdSectionChild,
  fourthSectionChild,
  fifthSectionChild,
  firstSectionChildURL,
  secondSectionChildURL,
  thirdSectionChildURL,
  fourthSectionChildURL,
  fifthSectionChildURL,
  firstSectionChildExternalURL,
  secondSectionChildExternalURL,
  thirdSectionChildExternalURL,
  fourthSectionChildExternalURL,
  fifthSectionChildExternalURL,
  navBackgroundColor,
  navColor,
  navPadding,
  navBorder,
  firstSection,
  secondSection,
  thirdSection,
  fourthSection,
  fifthSection,
  firstSectionHeight,
  secondSectionHeight,
  thirdSectionHeight,
  fourthSectionHeight,
  fifthSectionHeight,
  isPreview,
  showButtons
}) => {
  const [showOneButton, setOneButton] = useState(false);
  const [showTwoButton, setTwoButton] = useState(false);
  const [showThreeButton, setThreeButton] = useState(false);
  const [showFourButton, setFourButton] = useState(false);
  const [showFiveButton, setFiveButton] = useState(false);
  const [modalToShow, setModalToShow] = useState('');
  return (
    <>
      <StyledNav
        backcolor={navBackgroundColor}
        color={navColor}
        pad={navPadding}
        bordercolor={navBorder}
      >
        <Nav.Item>
          <Nav.Link style={{ color: navColor }} href={`#${firstSection}`}>
            {firstSection}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link style={{ color: navColor }} href={`#${secondSection}`}>
            {secondSection}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link style={{ color: navColor }} href={`#${thirdSection}`}>
            {thirdSection}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link style={{ color: navColor }} href={`#${fourthSection}`}>
            {fourthSection}
          </Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link style={{ color: navColor }} href={`#${fifthSection}`}>
            {fifthSection}
          </Nav.Link>
        </Nav.Item>
      </StyledNav>
      <Section
        id={`${firstSection}`}
        height={firstSectionHeight}
        onMouseEnter={() => setOneButton(true)}
        onMouseLeave={() => setOneButton(false)}
      >
        {React.cloneElement(firstSectionChild, { isPreview })}
        {showButtons && (
          <>
            <ExpandModalButton
              showButton={showOneButton}
              handleShow={() => setModalToShow(MODALS.ONE)}
            />
            <OpenLinkInNewWindowButton showButton={showOneButton} linkURL={firstSectionChildURL} />
            <OpenLinkInNewWindowButton
              isExternal
              showButton={showOneButton}
              linkURL={firstSectionChildExternalURL}
            />
          </>
        )}
      </Section>
      <Section
        height={secondSectionHeight}
        id={`${secondSection}`}
        onMouseEnter={() => setTwoButton(true)}
        onMouseLeave={() => setTwoButton(false)}
      >
        {React.cloneElement(secondSectionChild, { isPreview })}
        {showButtons && (
          <>
            <ExpandModalButton
              showButton={showTwoButton}
              handleShow={() => setModalToShow(MODALS.TWO)}
            />
            <OpenLinkInNewWindowButton showButton={showTwoButton} linkURL={secondSectionChildURL} />
            <OpenLinkInNewWindowButton
              isExternal
              showButton={showTwoButton}
              linkURL={secondSectionChildExternalURL}
            />
          </>
        )}
      </Section>
      <Section
        height={thirdSectionHeight}
        id={`${thirdSection}`}
        onMouseEnter={() => setThreeButton(true)}
        onMouseLeave={() => setThreeButton(false)}
      >
        {React.cloneElement(thirdSectionChild, { isPreview })}
        {showButtons && (
          <>
            <ExpandModalButton
              showButton={showThreeButton}
              handleShow={() => setModalToShow(MODALS.THREE)}
            />
            <OpenLinkInNewWindowButton
              showButton={showThreeButton}
              linkURL={thirdSectionChildURL}
            />
            <OpenLinkInNewWindowButton
              isExternal
              showButton={showThreeButton}
              linkURL={thirdSectionChildExternalURL}
            />
          </>
        )}
      </Section>
      <Section
        height={fourthSectionHeight}
        id={`${fourthSection}`}
        onMouseEnter={() => setFourButton(true)}
        onMouseLeave={() => setFourButton(false)}
      >
        {React.cloneElement(fourthSectionChild, { isPreview })}
        {showButtons && (
          <>
            <ExpandModalButton
              showButton={showFourButton}
              handleShow={() => setModalToShow(MODALS.FOUR)}
            />
            <OpenLinkInNewWindowButton
              showButton={showFourButton}
              linkURL={fourthSectionChildURL}
            />
            <OpenLinkInNewWindowButton
              isExternal
              showButton={showFourButton}
              linkURL={fourthSectionChildExternalURL}
            />
          </>
        )}
      </Section>
      <Section
        height={fifthSectionHeight}
        id={`${fifthSection}`}
        onMouseEnter={() => setFiveButton(true)}
        onMouseLeave={() => setFiveButton(false)}
      >
        {React.cloneElement(fifthSectionChild, { isPreview })}
        {showButtons && (
          <>
            <ExpandModalButton
              showButton={showFiveButton}
              handleShow={() => setModalToShow(MODALS.FIVE)}
            />
            <OpenLinkInNewWindowButton showButton={showFiveButton} linkURL={fifthSectionChildURL} />
            <OpenLinkInNewWindowButton
              isExternal
              showButton={showFiveButton}
              linkURL={fifthSectionChildExternalURL}
            />
          </>
        )}
      </Section>
      <Modal
        show={!isEmpty(modalToShow)}
        onHide={() => setModalToShow('')}
        dialogClassName="w-75 mw-100 mh-100"
      >
        <Modal.Header closeButton />
        <Modal.Body className="p-0" style={{ height: '85vh', width: '100%' }}>
          {modalToShow === MODALS.ONE && firstSectionChild}
          {modalToShow === MODALS.TWO && secondSectionChild}
          {modalToShow === MODALS.THREE && thirdSectionChild}
          {modalToShow === MODALS.FOUR && fourthSectionChild}
          {modalToShow === MODALS.FIVE && fifthSectionChild}
        </Modal.Body>
      </Modal>
    </>
  );
};

SectionsFive.defaultProps = {
  navBackgroundColor: '#545554',
  navColor: 'black',
  navPadding: '4rem',
  navBorder: 'gray',
  firstSectionHeight: '18%',
  secondSectionHeight: '18%',
  thirdSectionHeight: '18%',
  fourthSectionHeight: '18%',
  fifthSectionHeight: '18%',
  firstSection: 'First Title',
  secondSection: 'Second Title',
  thirdSection: 'Third Title',
  fourthSection: 'Fourth Title',
  fifthSection: 'Fifth Title',
  firstSectionChild: <MapIframe />,
  secondSectionChild: <GraphicIframe />,
  thirdSectionChild: <TableIframe />,
  fourthSectionChild: <Text />,
  fifthSectionChild: <TableIframe />,
  firstSectionChildURL: defaultMapSource,
  secondSectionChildURL: defaultGraphicSource,
  thirdSectionChildURL: defaultTableSource,
  fourthSectionChildURL: '',
  fifthSectionChildURL: defaultTableSource,
  firstSectionChildExternalURL: '',
  secondSectionChildExternalURL: '',
  thirdSectionChildExternalURL: '',
  fourthSectionChildExternalURL: '',
  fifthSectionChildExternalURL: '',
  isPreview: false,
  showButtons: true
};

SectionsFive.propTypes = {
  navBackgroundColor: PropTypes.string,
  navColor: PropTypes.string,
  navPadding: PropTypes.string,
  navBorder: PropTypes.string,
  firstSectionHeight: PropTypes.string,
  secondSectionHeight: PropTypes.string,
  thirdSectionHeight: PropTypes.string,
  fourthSectionHeight: PropTypes.string,
  fifthSectionHeight: PropTypes.string,
  firstSection: PropTypes.string,
  secondSection: PropTypes.string,
  thirdSection: PropTypes.string,
  fourthSection: PropTypes.string,
  fifthSection: PropTypes.string,
  firstSectionChild: PropTypes.node,
  secondSectionChild: PropTypes.node,
  thirdSectionChild: PropTypes.node,
  fourthSectionChild: PropTypes.node,
  fifthSectionChild: PropTypes.node,
  firstSectionChildURL: PropTypes.string,
  secondSectionChildURL: PropTypes.string,
  thirdSectionChildURL: PropTypes.string,
  fourthSectionChildURL: PropTypes.string,
  fifthSectionChildURL: PropTypes.string,
  firstSectionChildExternalURL: PropTypes.string,
  secondSectionChildExternalURL: PropTypes.string,
  thirdSectionChildExternalURL: PropTypes.string,
  fourthSectionChildExternalURL: PropTypes.string,
  fifthSectionChildExternalURL: PropTypes.string,
  isPreview: PropTypes.bool,
  showButtons: PropTypes.bool
};

export default SectionsFive;
